function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavReports = function SvgNavReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M91.67,102.74V12.5c0-2.3-1.87-4.17-4.17-4.17C39.25,8.33,0,51.33,0,104.17s42.99,95.83,95.83,95.83c23.64,0,36.43-4.28,52.65-17.62,1.74-1.43,2.02-3.99.64-5.77l-57.46-73.87ZM95.83,191.67c-48.25,0-87.5-39.25-87.5-87.5S41.61,19.19,83.33,16.78v87.38c0,.92.31,1.82.88,2.56l55.8,71.74c-13.16,10.05-24.13,13.2-44.18,13.2Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.17,100h91.67c2.3,0,4.17-1.87,4.17-4.17C200,42.99,157.01,0,104.17,0c-2.3,0-4.17,1.87-4.17,4.17v91.67c0,2.3,1.87,4.17,4.17,4.17ZM108.33,8.43c44.94,2.12,81.12,38.29,83.23,83.23h-83.23V8.43Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.83,108.33h-83.33c-1.6,0-3.08.93-3.77,2.38-.69,1.45-.48,3.17.52,4.41l54.17,67.06c.72.91,1.79,1.46,2.95,1.54.1,0,.19,0,.29,0,1.05,0,2.07-.4,2.84-1.12,19.37-18.07,30.49-43.62,30.49-70.11,0-2.3-1.87-4.17-4.17-4.17Z",
    style: {
      fill: "#e3f9ff",
      strokeWidth: 0
    }
  }));
};
export default SvgNavReports;